export default "__VITE_ASSET__65cf0d36__"